import { Component } from 'react'
import { connect } from 'react-redux'
import FootprintsSearch from 'components/Footprints/Search'
import {
  fetchFootprints,
  showSearch,
  hideSearch,
  showFootprints
} from './actions'
import {
  selectError,
  selectSearchActive,
  selectIsFetching,
  selectId
} from './selectors'
import { OptionsHOC } from '../../hocs'

/**
 * The `SearchContainer` for the Footprints application tree.
 *
 * It handles user interactions such as clicking the search button, changing
 * the search input value, submitting the search form, and handling the search
 * input blur event.
 * The component also dispatches actions to fetch footprints data and show/hide
 * the search interface based on the user's interactions.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.error - The error object.
 * @param {boolean} props.isFetching - Whether the data is being fetched.
 * @param {boolean} props.searchActive - Whether the search interface is active.
 * @param {string} props.id - The ID of the selected footprint.
 * @param {Function} props.fetchFootprints - The function to fetch footprints data.
 * @param {Function} props.showSearch - The function to show the search interface.
 * @param {Function} props.hideSearch - The function to hide the search interface.
 * @param {Function} props.showFootprints - The function to show the footprints.
 * @returns {JSX.Element} The SearchContainer component.
 */
class SearchContainer extends Component {
  state = { value: '' }

  componentDidMount() {
    // this.props.fetchFootprints('Z75PRL')
  }

  handleClick = () => {
    this.props.showSearch()
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value.toUpperCase() })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const value = this.state.value.trim()

    if (value === '') {
      return
    }

    if (value !== this.props.id) {
      this.props.fetchFootprints(this.state.value)
    } else {
      this.props.showFootprints()
    }
  }

  handleBlur = (e) => {
    const relatedTarget = e.relatedTarget || document.activeElement // IE11

    if (!relatedTarget || !e.currentTarget.contains(relatedTarget)) {
      this.props.hideSearch()
    }
  }

  render() {
    const props = {
      ...this.props,
      ...this.state,
      handleClick: this.handleClick,
      handleChange: this.handleChange,
      handleSubmit: this.handleSubmit,
      handleBlur: this.handleBlur,
      showFootprint: this.props.getOption('showFootprints')
    }
    return <FootprintsSearch {...props} />
  }
}

const mapStateToProps = (state) => ({
  error: selectError(state),
  searchActive: selectSearchActive(state),
  isFetching: selectIsFetching(state),
  id: selectId(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchFootprints: (id) => dispatch(fetchFootprints.request(id)),
  showSearch: () => dispatch(showSearch()),
  hideSearch: () => dispatch(hideSearch()),
  showFootprints: () => dispatch(showFootprints())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OptionsHOC(SearchContainer))
